module.exports = __webpack_public_path__ + "img/cleaf_banner_news.b21d7563.jpg";